import React from "react";
import { ScheduledSupplyDTO } from "../../../../models/ScheduledSupplyDTO";
import { OzonFilterToggle } from "../ui/OzonFilterToggle";
import { formatDate } from "../utils/date";

export function ScheduledSection({
                                     scheduledToShow,
                                     isLoading,
                                     ozonFilter,
                                     setOzonFilter,
                                     onDeleteRequest,
                                     innerRef,
                                 }: {
    scheduledToShow: ScheduledSupplyDTO[];
    isLoading: boolean;
    ozonFilter: boolean;
    setOzonFilter: (v: boolean) => void;
    onDeleteRequest: (s: ScheduledSupplyDTO) => void;
    innerRef: React.RefObject<HTMLDivElement | null>;
}) {
    return (
        <>
            <div ref={innerRef} style={{ marginTop: 18 }}>
                <h2 className="supplies-section-title">Планируемые (окно)</h2>
                <p className="supplies-section-note">
                    Планируемые поставки — это список на окно через 2 недели (неделю).{" "}
                    <b>Удаление влияет только на охваченную неделю</b>, не меняя правила шаблонов.
                </p>
            </div>

            <OzonFilterToggle name="scheduledFilter" value={ozonFilter} onChange={setOzonFilter} />

            <div className="admin-table-wrapper">
                <table className="admin_table supplies-table">
                    <thead>
                    <tr>
                        <th>Название</th>
                        <th>Дата отправки</th>
                        <th>Дата приёмки</th>
                        <th>Действия</th>
                    </tr>
                    </thead>

                    <tbody>
                    {isLoading && (
                        <tr>
                            <td colSpan={4} className="admin-table-loading">
                                <span className="admin-spinner" /> Загрузка...
                            </td>
                        </tr>
                    )}

                    {!isLoading &&
                        scheduledToShow.map((s: any) => (
                            <tr key={s.id}>
                                <td>{s.title}</td>
                                <td>{formatDate(s.departureDate)}</td>
                                <td>{formatDate(s.acceptanceDate)}</td>
                                <td>
                                    <div className="supplies-actions">
                                        <button
                                            className="admin-button-secondary admin-button-secondary--danger"
                                            onClick={() => onDeleteRequest(s)}
                                        >
                                            Удалить
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}

                    {!isLoading && scheduledToShow.length === 0 && (
                        <tr>
                            <td colSpan={4} className="admin-table-empty">
                                Нет планируемых для выбранного фильтра.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </>
    );
}
